import {
  ExamAttachmentsUpload,
} from "@/components/medical-records/ExamAttachmentsUpload";
import { ExamGallery, type AttachmentRow } from "@/components/medical-records/ExamGallery";
import type { ExamAttachmentUpload } from "@/hooks/useExamAttachments";
import { MobileDocumentsTab } from "@/components/medical-records/mobile/MobileDocumentsTab";

interface MedicalRecordDocumentsSectionProps {
  clinicId?: string | null;
  attachments: AttachmentRow[];
  isLoadingAttachments?: boolean;
  onUploadAttachments?: (items: ExamAttachmentUpload[]) => Promise<void>;
  onDeleteAttachment?: (attachment: AttachmentRow) => Promise<void>;
  onUpdateAttachment?: (payload: {
    attachmentId: string;
    name?: string | null;
    type: string;
    description: string | null;
    examDate: string | null;
    occurredAt?: string | null;
  }) => Promise<void>;
  readOnly?: boolean;
  variant?: "desktop" | "mobile";
}

export function MedicalRecordDocumentsSection({
  clinicId,
  attachments,
  isLoadingAttachments,
  onUploadAttachments,
  onDeleteAttachment,
  onUpdateAttachment,
  readOnly = false,
  variant = "desktop",
}: MedicalRecordDocumentsSectionProps) {
  const canUpload = Boolean(clinicId && onUploadAttachments && !readOnly);

  if (variant === "mobile") {
    return (
      <MobileDocumentsTab
        clinicId={clinicId}
        attachments={attachments}
        isLoading={isLoadingAttachments}
        onUpload={onUploadAttachments}
        onDelete={onDeleteAttachment}
        onUpdate={onUpdateAttachment}
        readOnly={readOnly}
      />
    );
  }

  return (
    <>
      {canUpload ? (
        <ExamAttachmentsUpload
          clinicId={clinicId}
          onUpload={onUploadAttachments}
        />
      ) : null}
      <ExamGallery
        attachments={attachments}
        isLoading={isLoadingAttachments}
        onDelete={readOnly ? undefined : onDeleteAttachment}
        onUpdate={readOnly ? undefined : onUpdateAttachment}
        readOnly={readOnly}
      />
    </>
  );
}
